import React from 'react';
import PropTypes from 'prop-types';

var styles$1 = {"cell":"zjmhW","header":"m9Hi3","selected":"K-3-A","editing":"AcpSA","singleSelection":"UlcAU","hideLastBlock":"cP0m6","editorWrapper":"Ctbxc","viewerWrapper":"qFPJU","hideFirstBlock":"fw8GA","editor":"mRJzc","edit":"tUuBO","view":"_6Bhyo","editingToolbarWrapper":"cVjSy","selectAll":"Yup70","disableSelection":"AhhCg"};

var styles = {"borderT":"Oolwr","borderB":"eklbx","borderL":"PqCZW","borderR":"nYVN3"};

var CellBorders = function CellBorders(_ref) {
  var borders = _ref.borders;
  return [(borders == null ? void 0 : borders.top) && /* @__PURE__ */React.createElement("div", {
    key: "top",
    style: {
      background: borders.top
    },
    className: styles.borderT
  }), (borders == null ? void 0 : borders.bottom) && /* @__PURE__ */React.createElement("div", {
    key: "bottom",
    style: {
      background: borders.bottom
    },
    className: styles.borderB
  }), (borders == null ? void 0 : borders.right) && /* @__PURE__ */React.createElement("div", {
    key: "right",
    style: {
      background: borders.right
    },
    className: styles.borderR
  }), (borders == null ? void 0 : borders.left) && /* @__PURE__ */React.createElement("div", {
    key: "left",
    style: {
      background: borders.left
    },
    className: styles.borderL
  })];
};
CellBorders.propTypes = {
  borders: PropTypes.object
};

export { CellBorders as C, styles$1 as s };

import 'wix-rich-content-plugin-table/dist/loadable/viewer/es/styles.viewer.min.global.css'